import Icon from '@/components/icon';
import Menu from '@/components/menu';
import Text from '@/components/text';
import Tooltip from '@/components/tooltip';
import useThemeMediaQuery from '@/hooks/use-theme-media-query';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { getBreakpoint } from '@/theme';
import { Box, Stack, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  datasourceIds: string[];
}

const useStyles = createUseStyles((theme: Theme) => ({
  datasourceMenu: {
    maxWidth: 500,
    '& .button:hover': {
      opacity: 0.9,
    },
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: 16,
    paddingTop: 16,
  },
  [getBreakpoint('sm')]: {
    datasourceMenu: {
      maxWidth: 'calc(100vw - 30px)',
    },
  },
}));

const MessageDatasourceMenu: FC<Props> = ({ datasourceIds }) => {
  const styles = useStyles();
  const { small } = useThemeMediaQuery();
  const { datasources } = useUserSettings();

  const TriggerEl = (
    <Tooltip title="Searched Data Sources" placement="bottom">
      <Icon name="manage-search" />
    </Tooltip>
  );

  return (
    <Menu
      trigger={TriggerEl}
      title="Searched Data Sources"
      anchorOrigin={{ vertical: 25, horizontal: small ? -40 : 0 }}
      transformOrigin={{ vertical: 'top', horizontal: small ? 'right' : 'left' }}
      className={styles.datasourceMenu}
      hideClose
    >
      <Box width="100%" px={1} boxSizing="border-box">
        <Stack gap={0.5} justifyContent="flex-start" maxWidth="100%">
          {datasourceIds.map((datasourceId, index) => {
            const datasource = datasources.find(({ id }) => id === datasourceId);
            let TitleEl: ReactNode = null;

            if (datasource) {
              const { isPublicInternet, name } = datasource;
              TitleEl = <Text size="small">{isPublicInternet ? 'Public Internet' : name}</Text>;
            } else {
              // console.warn('unknown datasource', datasourceId);
              TitleEl = (
                <Text italic size="small">
                  &lt;data source unavailable&gt;
                </Text>
              );
            }

            return (
              <Stack direction="row" gap={0.2} key={datasourceId}>
                <Text bold size="small">
                  {index + 1}.
                </Text>
                {TitleEl}
              </Stack>
            );
          })}
        </Stack>
      </Box>
    </Menu>
  );
};

export default MessageDatasourceMenu;
